import { AnimatePresence } from '@eversports/klimt-utilities/framer-motion'

import Footer from '../../components/Footer'
import Header from '../../components/Header'

import TechnicalNotes from './TechnicalNotes'

const TechnicalNotesScreen = () => {
  return (
    <>
      <Header />
      <AnimatePresence mode="wait">
        <TechnicalNotes />
      </AnimatePresence>
      <Footer />
    </>
  )
}

export default TechnicalNotesScreen
